/**
 * Comprehensive timezone to country code mapping
 * Covers ~300+ IANA timezones for accurate country detection
 *
 * Note: Some timezones have multiple aliases (e.g., Asia/Calcutta and Asia/Kolkata)
 * which are intentionally both included for maximum compatibility.
 */
export const timezoneToCountryMap = {
  // United States
  'America/New_York': 'us',
  'America/Chicago': 'us',
  'America/Denver': 'us',
  'America/Los_Angeles': 'us',
  'America/Phoenix': 'us',
  'America/Anchorage': 'us',
  'America/Adak': 'us',
  'America/Detroit': 'us',
  'America/Indiana/Indianapolis': 'us',
  'America/Indiana/Knox': 'us',
  'America/Indiana/Marengo': 'us',
  'America/Indiana/Petersburg': 'us',
  'America/Indiana/Tell_City': 'us',
  'America/Indiana/Vevay': 'us',
  'America/Indiana/Vincennes': 'us',
  'America/Indiana/Winamac': 'us',
  'America/Kentucky/Louisville': 'us',
  'America/Kentucky/Monticello': 'us',
  'America/Juneau': 'us',
  'America/Menominee': 'us',
  'America/Metlakatla': 'us',
  'America/Nome': 'us',
  'America/North_Dakota/Beulah': 'us',
  'America/North_Dakota/Center': 'us',
  'America/North_Dakota/New_Salem': 'us',
  'America/Sitka': 'us',
  'America/Yakutat': 'us',
  'America/Boise': 'us',
  'Pacific/Honolulu': 'us',
  'Pacific/Midway': 'us',
  'Pacific/Wake': 'us',
  'Pacific/Guam': 'us',
  'Pacific/Pago_Pago': 'as',

  // Canada
  'America/Toronto': 'ca',
  'America/Vancouver': 'ca',
  'America/Edmonton': 'ca',
  'America/Winnipeg': 'ca',
  'America/Halifax': 'ca',
  'America/St_Johns': 'ca',
  'America/Regina': 'ca',
  'America/Montreal': 'ca',
  'America/Calgary': 'ca',
  'America/Yellowknife': 'ca',
  'America/Whitehorse': 'ca',
  'America/Iqaluit': 'ca',
  'America/Moncton': 'ca',
  'America/Goose_Bay': 'ca',
  'America/Glace_Bay': 'ca',
  'America/Dawson': 'ca',
  'America/Dawson_Creek': 'ca',
  'America/Fort_Nelson': 'ca',
  'America/Creston': 'ca',
  'America/Pangnirtung': 'ca',
  'America/Resolute': 'ca',
  'America/Rankin_Inlet': 'ca',
  'America/Cambridge_Bay': 'ca',
  'America/Inuvik': 'ca',
  'America/Swift_Current': 'ca',
  'America/Atikokan': 'ca',
  'America/Nipigon': 'ca',
  'America/Thunder_Bay': 'ca',
  'America/Rainy_River': 'ca',
  'America/Blanc-Sablon': 'ca',

  // Mexico
  'America/Mexico_City': 'mx',
  'America/Cancun': 'mx',
  'America/Merida': 'mx',
  'America/Monterrey': 'mx',
  'America/Mazatlan': 'mx',
  'America/Chihuahua': 'mx',
  'America/Hermosillo': 'mx',
  'America/Tijuana': 'mx',
  'America/Matamoros': 'mx',
  'America/Ojinaga': 'mx',
  'America/Bahia_Banderas': 'mx',

  // Central America
  'America/Guatemala': 'gt',
  'America/Belize': 'bz',
  'America/El_Salvador': 'sv',
  'America/Tegucigalpa': 'hn',
  'America/Managua': 'ni',
  'America/Costa_Rica': 'cr',
  'America/Panama': 'pa',

  // Caribbean
  'America/Havana': 'cu',
  'America/Jamaica': 'jm',
  'America/Port-au-Prince': 'ht',
  'America/Santo_Domingo': 'do',
  'America/Puerto_Rico': 'pr',
  'America/Nassau': 'bs',
  'America/Barbados': 'bb',
  'America/Martinique': 'mq',
  'America/Guadeloupe': 'gp',
  'America/Port_of_Spain': 'tt',
  'America/Curacao': 'cw',
  'America/Aruba': 'aw',
  'America/Kralendijk': 'bq',
  'America/Lower_Princes': 'sx',
  'America/Marigot': 'mf',
  'America/St_Barthelemy': 'bl',
  'America/St_Kitts': 'kn',
  'America/St_Lucia': 'lc',
  'America/St_Thomas': 'vi',
  'America/St_Vincent': 'vc',
  'America/Tortola': 'vg',
  'America/Anguilla': 'ai',
  'America/Antigua': 'ag',
  'America/Dominica': 'dm',
  'America/Grenada': 'gd',
  'America/Montserrat': 'ms',
  'America/Cayman': 'ky',
  'America/Grand_Turk': 'tc',

  // South America
  'America/Bogota': 'co',
  'America/Lima': 'pe',
  'America/Caracas': 've',
  'America/Santiago': 'cl',
  'America/Punta_Arenas': 'cl',
  'Pacific/Easter': 'cl',
  'America/Argentina/Buenos_Aires': 'ar',
  'America/Argentina/Cordoba': 'ar',
  'America/Argentina/Salta': 'ar',
  'America/Argentina/Jujuy': 'ar',
  'America/Argentina/Tucuman': 'ar',
  'America/Argentina/Catamarca': 'ar',
  'America/Argentina/La_Rioja': 'ar',
  'America/Argentina/San_Juan': 'ar',
  'America/Argentina/Mendoza': 'ar',
  'America/Argentina/San_Luis': 'ar',
  'America/Argentina/Rio_Gallegos': 'ar',
  'America/Argentina/Ushuaia': 'ar',
  'America/Buenos_Aires': 'ar',
  'America/Sao_Paulo': 'br',
  'America/Rio_Branco': 'br',
  'America/Manaus': 'br',
  'America/Cuiaba': 'br',
  'America/Santarem': 'br',
  'America/Porto_Velho': 'br',
  'America/Boa_Vista': 'br',
  'America/Campo_Grande': 'br',
  'America/Belem': 'br',
  'America/Fortaleza': 'br',
  'America/Recife': 'br',
  'America/Araguaina': 'br',
  'America/Maceio': 'br',
  'America/Bahia': 'br',
  'America/Noronha': 'br',
  'America/Montevideo': 'uy',
  'America/Asuncion': 'py',
  'America/La_Paz': 'bo',
  'America/Guayaquil': 'ec',
  'Pacific/Galapagos': 'ec',
  'America/Guyana': 'gy',
  'America/Paramaribo': 'sr',
  'America/Cayenne': 'gf',
  'Atlantic/Stanley': 'fk',

  // Europe - Western
  'Europe/London': 'gb',
  'Europe/Dublin': 'ie',
  'Europe/Paris': 'fr',
  'Europe/Berlin': 'de',
  'Europe/Rome': 'it',
  'Europe/Madrid': 'es',
  'Atlantic/Canary': 'es',
  'Africa/Ceuta': 'es',
  'Europe/Amsterdam': 'nl',
  'Europe/Brussels': 'be',
  'Europe/Luxembourg': 'lu',
  'Europe/Vienna': 'at',
  'Europe/Zurich': 'ch',
  'Europe/Vaduz': 'li',
  'Europe/Monaco': 'mc',
  'Europe/Andorra': 'ad',
  'Europe/Gibraltar': 'gi',
  'Europe/San_Marino': 'sm',
  'Europe/Vatican': 'va',

  // Europe - Northern
  'Europe/Stockholm': 'se',
  'Europe/Oslo': 'no',
  'Europe/Copenhagen': 'dk',
  'Europe/Helsinki': 'fi',
  'Europe/Tallinn': 'ee',
  'Europe/Riga': 'lv',
  'Europe/Vilnius': 'lt',
  'Atlantic/Reykjavik': 'is',
  'Atlantic/Faroe': 'fo',
  'Arctic/Longyearbyen': 'sj',

  // Europe - Central & Eastern
  'Europe/Warsaw': 'pl',
  'Europe/Prague': 'cz',
  'Europe/Budapest': 'hu',
  'Europe/Bucharest': 'ro',
  'Europe/Sofia': 'bg',
  'Europe/Athens': 'gr',
  'Europe/Lisbon': 'pt',
  'Atlantic/Madeira': 'pt',
  'Atlantic/Azores': 'pt',
  'Europe/Belgrade': 'rs',
  'Europe/Zagreb': 'hr',
  'Europe/Ljubljana': 'si',
  'Europe/Sarajevo': 'ba',
  'Europe/Skopje': 'mk',
  'Europe/Podgorica': 'me',
  'Europe/Tirane': 'al',
  'Europe/Bratislava': 'sk',
  'Europe/Malta': 'mt',
  'Europe/Nicosia': 'cy',
  'Asia/Nicosia': 'cy',
  'Europe/Chisinau': 'md',

  // Europe - Eastern & Russia
  'Europe/Moscow': 'ru',
  'Europe/St_Petersburg': 'ru',
  'Europe/Kaliningrad': 'ru',
  'Europe/Volgograd': 'ru',
  'Europe/Samara': 'ru',
  'Europe/Saratov': 'ru',
  'Europe/Ulyanovsk': 'ru',
  'Europe/Kirov': 'ru',
  'Europe/Astrakhan': 'ru',
  'Asia/Yekaterinburg': 'ru',
  'Asia/Omsk': 'ru',
  'Asia/Novosibirsk': 'ru',
  'Asia/Barnaul': 'ru',
  'Asia/Tomsk': 'ru',
  'Asia/Novokuznetsk': 'ru',
  'Asia/Krasnoyarsk': 'ru',
  'Asia/Irkutsk': 'ru',
  'Asia/Chita': 'ru',
  'Asia/Yakutsk': 'ru',
  'Asia/Khandyga': 'ru',
  'Asia/Vladivostok': 'ru',
  'Asia/Ust-Nera': 'ru',
  'Asia/Magadan': 'ru',
  'Asia/Sakhalin': 'ru',
  'Asia/Srednekolymsk': 'ru',
  'Asia/Kamchatka': 'ru',
  'Asia/Anadyr': 'ru',
  'Europe/Kiev': 'ua',
  'Europe/Kyiv': 'ua',
  'Europe/Uzhgorod': 'ua',
  'Europe/Zaporozhye': 'ua',
  'Europe/Simferopol': 'ua',
  'Europe/Minsk': 'by',

  // Middle East
  'Asia/Dubai': 'ae',
  'Asia/Riyadh': 'sa',
  'Asia/Kuwait': 'kw',
  'Asia/Qatar': 'qa',
  'Asia/Bahrain': 'bh',
  'Asia/Muscat': 'om',
  'Asia/Aden': 'ye',
  'Asia/Baghdad': 'iq',
  'Asia/Tehran': 'ir',
  'Asia/Jerusalem': 'il',
  'Asia/Amman': 'jo',
  'Asia/Beirut': 'lb',
  'Asia/Damascus': 'sy',
  'Europe/Istanbul': 'tr',
  'Asia/Istanbul': 'tr',

  // Central Asia
  'Asia/Almaty': 'kz',
  'Asia/Qyzylorda': 'kz',
  'Asia/Qostanay': 'kz',
  'Asia/Aqtobe': 'kz',
  'Asia/Aqtau': 'kz',
  'Asia/Atyrau': 'kz',
  'Asia/Oral': 'kz',
  'Asia/Tashkent': 'uz',
  'Asia/Samarkand': 'uz',
  'Asia/Bishkek': 'kg',
  'Asia/Dushanbe': 'tj',
  'Asia/Ashgabat': 'tm',
  'Asia/Baku': 'az',
  'Asia/Tbilisi': 'ge',
  'Asia/Yerevan': 'am',

  // South Asia
  'Asia/Kolkata': 'in',
  'Asia/Calcutta': 'in',
  'Asia/Mumbai': 'in',
  'Asia/Karachi': 'pk',
  'Asia/Dhaka': 'bd',
  'Asia/Colombo': 'lk',
  'Asia/Kathmandu': 'np',
  'Asia/Thimphu': 'bt',
  'Indian/Maldives': 'mv',

  // Southeast Asia
  'Asia/Bangkok': 'th',
  'Asia/Jakarta': 'id',
  'Asia/Makassar': 'id',
  'Asia/Pontianak': 'id',
  'Asia/Jayapura': 'id',
  'Asia/Manila': 'ph',
  'Asia/Kuala_Lumpur': 'my',
  'Asia/Kuching': 'my',
  'Asia/Singapore': 'sg',
  'Asia/Ho_Chi_Minh': 'vn',
  'Asia/Saigon': 'vn',
  'Asia/Hanoi': 'vn',
  'Asia/Phnom_Penh': 'kh',
  'Asia/Vientiane': 'la',
  'Asia/Yangon': 'mm',
  'Asia/Rangoon': 'mm',
  'Asia/Brunei': 'bn',
  'Asia/Dili': 'tl',

  // East Asia
  'Asia/Tokyo': 'jp',
  'Asia/Shanghai': 'cn',
  'Asia/Chongqing': 'cn',
  'Asia/Harbin': 'cn',
  'Asia/Urumqi': 'cn',
  'Asia/Kashgar': 'cn',
  'Asia/Hong_Kong': 'hk',
  'Asia/Macau': 'mo',
  'Asia/Taipei': 'tw',
  'Asia/Seoul': 'kr',
  'Asia/Pyongyang': 'kp',
  'Asia/Ulaanbaatar': 'mn',
  'Asia/Hovd': 'mn',
  'Asia/Choibalsan': 'mn',

  // Australia
  'Australia/Sydney': 'au',
  'Australia/Melbourne': 'au',
  'Australia/Brisbane': 'au',
  'Australia/Perth': 'au',
  'Australia/Adelaide': 'au',
  'Australia/Darwin': 'au',
  'Australia/Hobart': 'au',
  'Australia/Canberra': 'au',
  'Australia/Lord_Howe': 'au',
  'Australia/Broken_Hill': 'au',
  'Australia/Lindeman': 'au',
  'Australia/Currie': 'au',
  'Australia/Eucla': 'au',
  'Indian/Christmas': 'cx',
  'Indian/Cocos': 'cc',

  // New Zealand & Pacific
  'Pacific/Auckland': 'nz',
  'Pacific/Chatham': 'nz',
  'Pacific/Fiji': 'fj',
  'Pacific/Tongatapu': 'to',
  'Pacific/Apia': 'ws',
  'Pacific/Noumea': 'nc',
  'Pacific/Port_Moresby': 'pg',
  'Pacific/Bougainville': 'pg',
  'Pacific/Guadalcanal': 'sb',
  'Pacific/Efate': 'vu',
  'Pacific/Tarawa': 'ki',
  'Pacific/Majuro': 'mh',
  'Pacific/Kwajalein': 'mh',
  'Pacific/Kosrae': 'fm',
  'Pacific/Pohnpei': 'fm',
  'Pacific/Chuuk': 'fm',
  'Pacific/Palau': 'pw',
  'Pacific/Nauru': 'nr',
  'Pacific/Funafuti': 'tv',
  'Pacific/Wallis': 'wf',
  'Pacific/Tahiti': 'pf',
  'Pacific/Marquesas': 'pf',
  'Pacific/Gambier': 'pf',
  'Pacific/Rarotonga': 'ck',
  'Pacific/Niue': 'nu',
  'Pacific/Pitcairn': 'pn',
  'Pacific/Norfolk': 'nf',

  // Africa - North
  'Africa/Cairo': 'eg',
  'Africa/Tripoli': 'ly',
  'Africa/Tunis': 'tn',
  'Africa/Algiers': 'dz',
  'Africa/Casablanca': 'ma',
  'Africa/El_Aaiun': 'eh',

  // Africa - West
  'Africa/Lagos': 'ng',
  'Africa/Accra': 'gh',
  'Africa/Abidjan': 'ci',
  'Africa/Dakar': 'sn',
  'Africa/Bamako': 'ml',
  'Africa/Ouagadougou': 'bf',
  'Africa/Niamey': 'ne',
  'Africa/Nouakchott': 'mr',
  'Africa/Conakry': 'gn',
  'Africa/Freetown': 'sl',
  'Africa/Monrovia': 'lr',
  'Africa/Banjul': 'gm',
  'Africa/Bissau': 'gw',
  'Atlantic/Cape_Verde': 'cv',
  'Africa/Sao_Tome': 'st',
  'Africa/Lome': 'tg',
  'Africa/Porto-Novo': 'bj',
  'Africa/Ndjamena': 'td',

  // Africa - Central
  'Africa/Kinshasa': 'cd',
  'Africa/Lubumbashi': 'cd',
  'Africa/Brazzaville': 'cg',
  'Africa/Bangui': 'cf',
  'Africa/Douala': 'cm',
  'Africa/Malabo': 'gq',
  'Africa/Libreville': 'ga',
  'Africa/Luanda': 'ao',

  // Africa - East
  'Africa/Nairobi': 'ke',
  'Africa/Dar_es_Salaam': 'tz',
  'Africa/Kampala': 'ug',
  'Africa/Addis_Ababa': 'et',
  'Africa/Mogadishu': 'so',
  'Africa/Asmara': 'er',
  'Africa/Djibouti': 'dj',
  'Indian/Antananarivo': 'mg',
  'Indian/Mauritius': 'mu',
  'Indian/Reunion': 're',
  'Indian/Mayotte': 'yt',
  'Indian/Comoro': 'km',
  'Africa/Kigali': 'rw',
  'Africa/Bujumbura': 'bi',
  'Africa/Juba': 'ss',
  'Africa/Khartoum': 'sd',

  // Africa - Southern
  'Africa/Johannesburg': 'za',
  'Africa/Harare': 'zw',
  'Africa/Lusaka': 'zm',
  'Africa/Maputo': 'mz',
  'Africa/Blantyre': 'mw',
  'Africa/Gaborone': 'bw',
  'Africa/Windhoek': 'na',
  'Africa/Maseru': 'ls',
  'Africa/Mbabane': 'sz',

  // Atlantic
  'Atlantic/Bermuda': 'bm',
  'Atlantic/South_Georgia': 'gs',
  'Atlantic/St_Helena': 'sh',

  // Indian Ocean
  'Indian/Seychelles': 'sc',
  'Indian/Chagos': 'io',
};
